import * as React from 'react';
import Card from '@mui/material/Card';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Hint } from '../../view/Hint';
import { Translate } from '../../../../../../../shared/LanguageService';

type BookingMethodSectionProps = {
    value: BookingMethod;
    onChange: (bookingMethod: string) => void;
    showHint: boolean;
};

export enum BookingMethod {
    TimeCentric = 'timecentric',
    PhotographerCentric = 'photographercentric'
}

export function BookingMethodSection({ value, onChange, showHint }: BookingMethodSectionProps) {
    const timeCentricId = 'timeslot-centric';
    const photographerCentricId = 'photographer-centric';

    return (
        <Box sx={{ padding: '20px 0', width: '100%' }}>
            <Hint showHint={showHint}>
                {Translate('se360/photographerbooking/customer/calendar/booking-method/hint')}
            </Hint>
            <Box sx={{ paddingTop: '8px', width: '100%' }}>
                <Card sx={{ padding: '20px' }}>
                    <Typography
                        variant="h2"
                        sx={{
                            fontSize: '1.8rem',
                            paddingBottom: '8px',
                            color: 'text.secondary',
                            fontFamily: 'Gilroy'
                        }}
                    >
                        {Translate(
                            'se360/photographerbooking/customer/calendar/booking-method/title'
                        )}
                    </Typography>
                    <RadioGroup
                        name="booking-method"
                        aria-label={Translate('se360/photographerbooking/customer/calendar/booking-method/hint')}
                        value={value}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            let val = event.target.value;
                            onChange(val);
                        }}
                    >
                        <Box
                            component="label"
                            htmlFor={timeCentricId}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                margin: 0
                            }}
                        >
                            <Radio
                                id={timeCentricId}
                                value={BookingMethod.TimeCentric}
                                checkedIcon={<CheckCircleIcon sx={{ color: 'secondary.dark' }} />}
                            />
                            <Typography
                                variant="body1"
                                sx={{
                                    fontFamily: 'Gilroy',
                                    fontSize: '1.4rem'
                                }}
                            >
                                {Translate(
                                    'se360/photographerbooking/customer/calendar/booking-method/option1'
                                )}
                            </Typography>
                        </Box>
                        <Box
                            component="label"
                            htmlFor={photographerCentricId}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                margin: 0
                            }}
                        >
                            <Radio
                                id={photographerCentricId}
                                value={BookingMethod.PhotographerCentric}
                                checkedIcon={<CheckCircleIcon sx={{ color: 'secondary.dark' }} />}
                            />
                            <Typography
                                variant="body1"
                                sx={{
                                    fontFamily: 'Gilroy',
                                    fontSize: '1.4rem'
                                }}
                            >
                                {Translate(
                                    'se360/photographerbooking/customer/calendar/booking-method/option2'
                                )}
                            </Typography>
                        </Box>
                    </RadioGroup>
                </Card>
            </Box>
        </Box>
    );
}
